import React, { JSX } from 'react';
import { ApiFlightItem } from '@ibe/api';

import { sanitize } from '@ibe/services';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import { Price } from '../../Components/UI/Price/Price';
import Keys from '../../../_Translations/generated/flight-summary.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/flight-summary.en.t.json';
import Dates from '../Dates';

const Cart = (props: BookedItemComponentProps): JSX.Element => {
  const { item, booking } = props;
  const flight = booking.items.find(it => it.id === item.idParent) as ApiFlightItem;
  const price = item.price || null;
  const description = item.description || null;
  const isRoundTrip = flight.segment.length > 1;
  const { t } = useTranslation('flight-summary', fallback, Keys);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div>
        <h6 className="my-0">{isRoundTrip ? t(Keys.roundtrip) : t(Keys.oneway)}</h6>
        <Dates item={item} />
        {description && <div dangerouslySetInnerHTML={{ __html: sanitize(description) }} />}
      </div>
      <span className="text-muted ml-1">{price && <Price price={price} />}</span>
    </div>
  );
};

export default Cart;
